/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：397
 */

module.exports = {
  inputRow: "style_inputRow__1hfPD",
  mask: "style_mask__7vbTr",
  text: "style_text__3aYgd",
  lockWrapper: "style_lockWrapper__2_Tk3",
  imageBox: "style_imageBox__9FmI7",
  edit: "style_edit__1P4mW",
  btn: "style_btn__3keWd",
  form: "style_form__1im9H",
  formItem: "style_formItem__1yS2r",
  placeholder: "style_placeholder__3RFbi"
}
